module.exports = __webpack_public_path__ + "static/img/bkg-top-aniversario.c5768e9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bkg-top-aniversario.jpg
// module id = KVvj
// module chunks = 0